<template>
  <div>
    <div
      v-if="warehouse === null || warehouse === undefined"
      class="m-5 p-5 text-center bold-40"
    >
      {{ $t("productHistory.noWarehouseSelected2") }}
    </div>
    <div
      v-else-if="selectedWarehouse?.type !== 3"
      class="m-5 p-5 text-center bold-40"
    >
      {{ $t("order.thisWarehouseNotARetailType") }}
    </div>
    <div class="row gap-3" v-else>
      <div class="col">
        <router-link to="/sales/collects" class="btn btn-secondary btn-no-r">
          <span><BaseIcon name="active" /> {{ $t("order.collectList") }}</span>
        </router-link>
        <router-link
          to="/sales/products"
          class="btn btn-no-r btn-no-l"
          :class="type == 'sales' ? 'btn-primary' : 'btn-secondary'"
        >
          <span><BaseIcon name="box" /> {{ $t("order.packingList") }}</span>
        </router-link>
        <router-link
          to="/sales/delivery-notes"
          class="btn btn-secondary btn-no-r btn-no-l"
        >
          <span
            ><BaseIcon name="delivery-info" />
            {{ $t("salesCollectList.deliveryNotes") }}</span
          >
        </router-link>
        <router-link
          to="/sales/products/problems"
          class="btn btn-no-r btn-no-l"
          :class="type == 'problems' ? 'btn-primary' : 'btn-secondary'"
        >
          <span
            ><BaseIcon name="box-error" /> {{ $t("order.ProblemList") }}</span
          >
        </router-link>
        <router-link
          to="/sales/return"
          class="btn btn-no-l"
          :class="type === 'return' ? 'btn-primary' : 'btn-secondary'"
        >
          <span
            ><BaseIcon name="truck-remove" /> {{ $t("order.returnList") }}</span
          >
        </router-link>
      </div>
      <div class="col-auto text-end">
        <button v-on:click="loadData" class="btn btn-type-2 btn-small">
          <span
            ><BaseIcon name="refresh" />
            {{ $t("salesCollectList.refresh") }}</span
          >
        </button>
      </div>
      <div class="col-12" v-if="orders === undefined">
        <div
          v-for="i in 3"
          :key="i"
          class="nature-white-box no-min-height mb-3"
        >
          <div class="row mt-3 mb-4 ms-2">
            <div class="col">
              <h2>
                <Skeletor :width="Math.random() * 21 + 30 + '%'" />
              </h2>
              <div>
                <span>
                  <Skeletor :width="Math.random() * 10 + 10 + '%'" />
                </span>
              </div>
            </div>
          </div>
          <Skeletor class="p-3 my-1" :width="Math.random() * 30 + 70 + '%'" />
          <Skeletor
            class="p-3 my-1"
            :width="Math.random() * 30 + 70 + '%'"
            v-if="Math.random() > 0.3"
          />
          <Skeletor
            class="p-3 my-1"
            :width="Math.random() * 30 + 70 + '%'"
            v-if="Math.random() > 0.6"
          />
          <Skeletor
            class="p-3 my-1"
            :width="Math.random() * 30 + 70 + '%'"
            v-if="Math.random() > 0.9"
          />
        </div>
      </div>
      <div v-else class="col-12">
        <div v-if="orders.length === 0" class="text-center mt-4">
          <Vue3Lottie :animationData="emptyJSON" :height="160" :width="300" />
          <div class="bold-40 m-2 p-5">
            {{ $t("salesProductList.thereIsNothingToPack") }}
          </div>
        </div>
        <div
          class="nature-white-box no-min-height mb-3"
          v-for="order in filteredOrders"
          :key="order.id"
        >
          <div class="white-box-top"></div>
          <div class="row mt-3 mb-4 ms-2">
            <div class="col">
              <h2>{{ order.first_name }} {{ order.last_name }}</h2>
              <div>
                <span class="badge">
                  <router-link
                    :to="'/sales/' + order.id"
                    class="text-start text-white"
                    target="_blank"
                  >
                    {{ order.pretty_id }}
                  </router-link>
                </span>
                <span
                  v-if="order.courier_code"
                  class="badge ms-2"
                  :class="{
                    info: order.courier_code?.indexOf('gls') == 0,
                    failed:
                      order.courier_code == 'foxpost' ||
                      order.courier_code?.indexOf('dpd') == 0 ||
                      order.courier_code?.indexOf('sameday') == 0,
                    successful: order.courier_code == 'mpl',
                    warning: order.courier_code == 'dhl-express',
                  }"
                >
                  <img
                    :src="order.icon"
                    v-if="order.icon"
                    style="width: 14px; height: 14px"
                  />
                  {{ order.courier_name }}
                </span>
                <span
                  v-if="type === 'return' && order.public_tracking_code"
                  class="badge ms-2 d-inline-block"
                  >{{ order.public_tracking_code }}</span
                >
                <span v-if="type === 'return'" class="ms-2">
                  <span
                    class="badge py-0"
                    :class="deliveredStatuses[order.delivered_status].color"
                  >
                    <BaseIcon
                      :name="
                        deliveredStatuses[order.delivered_status]
                          ? deliveredStatuses[order.delivered_status].icon
                          : 'box-search'
                      "
                    />
                    {{
                      deliveredStatuses[order.delivered_status]
                        ? deliveredStatuses[order.delivered_status].name
                        : "Waiting"
                    }}
                  </span>
                </span>

                <span class="ms-1" v-if="order.comment">{{
                  $t(`salesProductList.comment`, { comment: order.comment })
                }}</span>
              </div>
            </div>
            <div
              class="col-auto custom-input whitebg-input"
              v-if="type !== 'return'"
            >
              <div class="input-group mb-1 px-0 py-2">
                <span class="input-group-text">
                  <button
                    class="btn btn-link"
                    v-on:click="
                      () => {
                        if (order.packages > 1) {
                          order.packages--;
                        }
                      }
                    "
                  >
                    <BaseIcon name="minus-circle" />
                  </button>
                  <input
                    type="number"
                    class="form-control w-4rem"
                    v-model="order.packages"
                  />
                  <button
                    class="btn btn-link"
                    v-on:click="
                      () => {
                        order.packages++;
                      }
                    "
                  >
                    <BaseIcon name="plus-circle" />
                  </button>
                </span>
              </div>
            </div>
            <div class="col-auto mt-2 me-3">
              <button
                class="btn btn-success btn-no-r"
                data-bs-placement="top"
                :title="$t(`salesProductList.printLabel`)"
                v-on:click="printLabel(order.tracking_code, order.app_id)"
                :class="{ 'loading-spin': order.loadShipBtn }"
                v-if="order.tracking_code !== undefined"
              >
                <BaseIcon name="printer" />
              </button>
              <button
                class="btn btn-primary btn-no-r"
                data-bs-placement="top"
                :title="$t(`order.createDelivery`)"
                :disabled="
                  order.loadShipBtn ||
                  (barcodeQueues[
                    order.order_package_id
                      ? order.id + '_' + order.order_package_id
                      : order.id
                  ] &&
                    barcodeQueues[
                      order.order_package_id
                        ? order.id + '_' + order.order_package_id
                        : order.id
                    ].length > 0)
                "
                v-on:click="showSelectShipping(order)"
                :class="{ 'loading-spin': order.loadShipBtn }"
                v-else-if="
                  type !== 'return' && order.delivery_method_id === null
                "
              >
                <BaseIcon name="box-add" />
              </button>
              <button
                class="btn btn-primary btn-no-r"
                data-bs-placement="top"
                :title="$t(`order.createDelivery`)"
                :disabled="
                  order.loadShipBtn ||
                  (barcodeQueues[
                    order.order_package_id
                      ? order.id + '_' + order.order_package_id
                      : order.id
                  ] &&
                    barcodeQueues[
                      order.order_package_id
                        ? order.id + '_' + order.order_package_id
                        : order.id
                    ].length > 0)
                "
                v-on:click="generateShipping(order)"
                :class="{ 'loading-spin': order.loadShipBtn }"
                v-else-if="type !== 'return'"
              >
                <BaseIcon name="box-add" />
              </button>
              <button
                class="btn btn-secondary btn-no-r btn-no-l"
                data-bs-placement="top"
                :title="$t(`salesCollectList.setToProblem`)"
                v-on:click="showProblemModal(order)"
                v-if="type === 'sales'"
              >
                <BaseIcon name="info-circle" />
              </button>
              <button
                class="btn btn-secondary btn-no-r btn-no-l"
                data-bs-placement="top"
                :title="$t(`salesCollectList.setToProblem`)"
                v-on:click="showMessagesModal(order)"
                v-if="type === 'problems'"
              >
                <BaseIcon name="mail" />
              </button>
              <button
                class="btn btn-secondary text-danger"
                data-bs-placement="top"
                :title="$t(`salesCollectList.setCollected`)"
                :disabled="order.loadCollectBtn"
                v-on:click="setCollected(order)"
                :class="{
                  'loading-spin': order.loadCollectBtn,
                  'btn-no-l': type !== 'return',
                }"
              >
                <BaseIcon name="tick-circle" />
              </button>
            </div>
            <div class="col-6 custom-input whitebg-input">
              <label class="input-group mb-1">
                <span class="input-group-text me-3">
                  <BaseIcon
                    v-if="
                      !barcodeQueues[
                        order.order_package_id
                          ? order.id + '_' + order.order_package_id
                          : order.id
                      ] ||
                      barcodeQueues[
                        order.order_package_id
                          ? order.id + '_' + order.order_package_id
                          : order.id
                      ].length === 0
                    "
                    :name="order.show_success ? 'tick-circle' : 'scanner'"
                  />
                  <div
                    v-else
                    class="spinner-border spinner-border-sm text-primary"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </span>
                <input
                  :placeholder="$t(`salesProductList.readBarcode`)"
                  type="text"
                  class="form-control"
                  v-model="order.barcode"
                  :disabled="order.disable"
                  :ref="
                    order.order_package_id
                      ? 'serach_box_' + order.id + '_' + order.order_package_id
                      : 'serach_box_' + order.id
                  "
                  v-on:focusin="startOrderTracking(order)"
                  v-on:change="
                    addToQueue(
                      order.id,
                      $event.target.value,
                      order.order_package_id
                    )
                  "
                />
              </label>
            </div>
          </div>
          <div v-for="panel in panels" :key="panel.id">
            <component
              :is="panel.component"
              :model-value="order"
              :key="panel.id"
            />
          </div>
          <div
            class="d-flex gap-3 align-items-center mb-4"
            v-if="order.extraItems"
          >
            <h3 class="bold-16">Extra items:</h3>
            <div
              class="row col-2"
              v-for="extraItem in order.extraItems"
              :key="extraItem.id"
            >
              <div class="col-auto">
                <BaseIcon name="no-image" class="product-image" />
              </div>
              <div class="col">
                <div class="bold-14">
                  {{ extraItem.serial }}
                </div>
                <div class="regular-14">
                  {{ extraItem.sku }}
                </div>
              </div>
            </div>
          </div>
          <one-by-one-table
            v-model:rows="rows"
            v-model:items="order.orderItems"
            :show-del="this.type === 'return'"
            :show-add="false"
            :show-edit="false"
            v-on:delete="(d) => cancelReturnModal(order, d)"
            type="products"
          />
        </div>
      </div>
      <ScanModal
        ref="packagingModal"
        :title="packagingInfo.status"
        :text="packagingInfo.text"
        :icon="packagingInfo.icon"
        v-model:selected-items="packagingInfo.selectedItems"
        :select-item-method="packagingInfo.selectItemMethod"
        v-on:hidden="onScanModalHidden"
      />
      <ConfirmModal
        ref="confirmModal"
        :title="$t(`salesProductList.removeItem`)"
        :text="$t(`salesProductList.removeItemText`)"
        cancel-button="No, keep it"
        ok-button="Yes, remove"
        v-on:success="cancelReturn"
      />
      <ConfirmModal
        ref="confirmPackingModal"
        :title="$t(`salesProductList.noBoxError`)"
        :text="$t(`salesProductList.noBoxErrorText`)"
        cancel-button="No, cancel"
        ok-button="Yes, create"
        v-on:success="generateShipping(packingOrder, true)"
      />
      <PrinterSelect
        :show="showPrinterModal"
        :printers="localPrinters"
        :method="currentPrintJob?.method"
        @choose="onPrinterChosen"
        @cancel="showPrinterModal = false"
      />
      <Modal ref="selectDeliveryModal" :title="$t(`newSale.selectDelivery`)">
        <div class="d-grid gap-2 grid-2" v-if="webshops.length > 0">
          <button
            class="btn btn-outline-primary"
            v-for="deliveryMethod in webshops
              .find((e) => e.id == packingOrder.webshop_id)
              .deliveryMethods?.filter((e) => e.is_delivery && e.type == 1)"
            :key="deliveryMethod.id"
            v-on:click="addDeliveryMethodAndPrint(packingOrder, deliveryMethod)"
          >
            <img :src="deliveryMethod.logo" class="w-25" />
            <div class="mt-2">
              {{ deliveryMethod.name }}
            </div>
          </button>
        </div>
      </Modal>
      <Modal
        ref="selectProblemModal"
        :title="$t(`salesProductList.selectProblem`)"
      >
        <div v-if="problems.length == 0">
          <Vue3Lottie
            :animationData="searchingJSON"
            :height="160"
            :width="300"
          />
        </div>
        <div class="d-grid gap-2 grid-2" v-else>
          <button
            class="btn btn-outline-primary"
            v-for="problem in problems"
            :key="problem.id"
            v-on:click="addProblem(packingOrder, problem)"
          >
            <div class="mt-2 bold-16">
              {{ problem.name }}
            </div>
            <div class="mt-2 regular-12">
              {{ problem.description }}
            </div>
          </button>
        </div>
      </Modal>
      <Modal ref="messagesModal" :title="$t(`salesProductList.messages`)">
        <div v-if="messages === undefined">
          <Vue3Lottie
            :animationData="searchingJSON"
            :height="160"
            :width="300"
          />
        </div>
        <div v-else-if="messages.length === 0">
          <Vue3Lottie :animationData="emptyJSON" :height="160" :width="300" />
        </div>
        <div v-else>
          <div
            v-for="message in messages"
            :key="message.id"
            class="contact-message"
          >
            <div class="contact-message-meta">
              <b>{{ formatDate(message.posted_at) }}</b
              ><br />
              <b>{{ message.title }}</b>
              <br />
              <span>{{ message.email }}</span>
            </div>
            <div class="contact-message-content" v-html="message.text"></div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import OneByOneTable from "../../components/lists/OneByOneTable";
import http from "@/modules/http";
import { defineAsyncComponent } from "vue";
import BaseIcon from "@/components/icons/BaseIcon";
import ScanModal from "@/components/modals/ScanModal";
import ws from "@/modules/ws";
import { useStore } from "vuex";
import ConfirmModal from "@/components/modals/ConfirmModal";
import printJS from "print-js";
import store from "@/store";
import deliveredStatuses from "@/modules/DeliveredStatuses";
import tenant from "../../modules/tenant";
import { Vue3Lottie } from "vue3-lottie";
import emptyJSON from "../../assets/animations/ghost.json";
import searchingJSON from "../../assets/animations/searching.json";
import PrinterSelect from "../../components/modals/PrinterSelect.vue";
import Modal from "../../components/modals/Modal.vue";
import barcodeFormat from "../../modules/barcodeFormat";
import date from "../../modules/date";
import TimeTracking from "../../modules/TimeTracking";
import externalComponent from "../../modules/externalComponent";
export default {
  name: "SalesProductList",
  components: {
    Modal,
    PrinterSelect,
    Vue3Lottie,
    ConfirmModal,
    ScanModal,
    BaseIcon,
    OneByOneTable,
  },
  data() {
    return {
      store: useStore(),
      deliveredStatuses: deliveredStatuses,
      emptyJSON: emptyJSON,
      searchingJSON: searchingJSON,
      packingOrder: null,
      messages: undefined,
      rows: [
        {
          name: "Trolley bin code",
          key: "bin_code",
          type: "text",
          show: true,
          editable: false,
        },
        {
          name: "image",
          key: "image",
          type: "image",
          show: true,
          editable: false,
        },
        {
          name: "Serial",
          key: "serial",
          component: defineAsyncComponent(() =>
            import("../../components/lists/listItems/Serial")
          ),
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Name",
          key: "name",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Quantity",
          key: "quantity",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "Left",
          key: "need_to_sent_quantity",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "Price",
          key: "payed_price",
          type: "price",
          show: true,
          editable: false,
        },
        {
          name: "SKU",
          key: "sku",
          type: "string",
          show: true,
          editable: false,
        },
      ],
      webshops: [],
      problems: [],
      firstLoad: true,
      orders: undefined,
      itemsById: {},
      ordersById: {},
      cancelItem: {},
      currentPartCount: {},
      panels: [],
      packagingInfo: {
        icon: null,
        status: "",
        text: "",
        selectedItems: [],
        selectItemMethod: null,
      },
      barcodeQueues: {},
      isProcessingQueue: {},

      //printers desktop app connection
      localPrinters: [],
      defaultPrinters: {},
      currentPrintJob: null,
      showPrinterModal: false,
    };
  },
  computed: {
    filteredOrders() {
      if (this.q === null || this.q.length < 2) {
        return this.orders;
      }
      let spacePos = this.q.indexOf(" ");
      if (spacePos < 2) {
        spacePos = this.q.length;
      }

      let q = barcodeFormat.normalizeInput(this.q);
      const searchVariants = /^\d+$/.test(q) ? barcodeFormat.normalize(q) : [q];

      return this.orders.filter(
        (e) =>
          e.orderItems.findIndex((g) => {
            const fields = [
              g.sku,
              g.ean,
              g.upc,
              typeof g.bin_code === "string" ? g.bin_code : null,
            ];
            return fields.some((field) =>
              barcodeFormat
                .normalize(field)
                .some((variant) =>
                  searchVariants.some((sv) =>
                    variant.toLowerCase().startsWith(sv)
                  )
                )
            );
          }) > -1 ||
          (e?.public_tracking_code
            ?.toLowerCase()
            ?.indexOf(q.substr(2, q.length - 4)) > -1 &&
            e?.public_tracking_code
              ?.toLowerCase()
              ?.indexOf(q.substr(2, q.length - 4)) < 6) ||
          (q?.indexOf(e?.public_tracking_code?.toLowerCase()) > -1 &&
            q?.indexOf(e?.public_tracking_code?.toLowerCase()) < 6) ||
          e?.pretty_id?.toLowerCase()?.indexOf(q) > -1 ||
          (e?.first_name?.toLowerCase()?.indexOf(q.substr(0, spacePos)) > -1 &&
            e?.last_name?.toLowerCase()?.indexOf(q.substr(spacePos, 100)) >
              -1) ||
          (e?.last_name?.toLowerCase()?.indexOf(q.substr(0, spacePos)) > -1 &&
            e?.first_name?.toLowerCase()?.indexOf(q.substr(spacePos, 100)) > -1)
      );
    },
    type() {
      return this.$router.currentRoute.value.meta?.type;
    },
    warehouse() {
      return this.store.state.topBar.warehouse;
    },
    warehouses() {
      return this.store.state.warehouses;
    },
    selectedWarehouse() {
      return this.warehouses.find((e) => e.id === this.warehouse);
    },
    q() {
      return this.store.state.topBar.q;
    },
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
  },
  watch: {
    warehouse() {
      this.loadData();
    },
    type() {
      this.loadData();
    },
    q(newValue, oldValue) {
      if (newValue?.length < oldValue?.length) {
        return;
      }
      if (this.filteredOrders?.length === 1) {
        let oid = this.filteredOrders[0].order_package_id
          ? "serach_box_" +
            this.filteredOrders[0].id +
            "_" +
            this.filteredOrders[0].order_package_id
          : "serach_box_" + this.filteredOrders[0].id;

        setTimeout(() => this.$refs[oid][0].focus(), 300);
      }
    },
  },
  mounted() {
    this.loadPanels();
    TimeTracking.start({
      event: this.type === "return" ? "returning" : "packing",
    });
    ws.init();

    ws.subscribe("modify", "orderItem", (e) => {
      if (
        e.rowKey === "collected" ||
        e.rowKey === "in_package" ||
        e.rowKey === "quantity" ||
        e.rowKey === "returned" ||
        e.rowKey === "need_to_sent_quantity"
      ) {
        let obj = this.itemsById[e.objectId];
        if (obj !== undefined) {
          obj[e.rowKey] = e.value;
        }
      }
    });

    this.loadData();
    document.getElementById("search-bar").focus();
    document.getElementById("search-bar").select();

    const _this = this;

    (async () => {
      try {
        const res = await fetch("http://0.0.0.0:54123/printers");
        if (!res.ok) throw new Error();

        const data = await res.json();
        _this.localPrinters = data.printers;
        for (const printer of _this.localPrinters) {
          for (const type of printer.defaultForTypes) {
            _this.defaultPrinters[type] = printer.id;
          }
        }
        console.log("Local printers detected:", data.printers);
      } catch {
        console.log("No local print service found");
      }
    })();
  },
  beforeUnmount() {
    if (TimeTracking.isTracking()) {
      TimeTracking.stop();
    }
  },
  methods: {
    async loadPanels() {
      const apps = this.store.state.apps;
      const loaders = [];
      const _this = this;

      for (const key in apps) {
        if (!apps[key].collectingListComponents) continue;
        console.log(key);
        for (const compKey in apps[key].collectingListComponents) {
          const comp = apps[key].collectingListComponents[compKey];

          const panelId = `${apps[key].name}_${comp.name}`;
          console.log(panelId);
          comp.app = apps[key].name;
          comp.id = panelId;

          loaders.push(
            externalComponent(
              `/${apps[key].name}/components/${comp.name}.umd.min.js`
            ).then((MyComponent) => {
              comp.component = MyComponent;
              _this.panels.push(comp);
            })
          );
        }
      }

      // wait for ALL components
      if (loaders.length) {
        await Promise.all(loaders);
      }
    },
    loadData() {
      if (this.type === "return") {
        let tmpi = this.rows.findIndex((e) => e.key === "returned");
        if (tmpi < 0) {
          this.rows.push({
            name: "Returned",
            key: "returned",
            type: "boolean",
            show: true,
            editable: false,
            center: true,
          });
        }
        tmpi = this.rows.findIndex((e) => e.key === "collected");
        if (tmpi > -1) {
          this.rows.splice(tmpi, 1);
        }
        tmpi = this.rows.findIndex((e) => e.key === "in_package");
        if (tmpi > -1) {
          this.rows.splice(tmpi, 1);
        }
      } else {
        let tmpi = this.rows.findIndex((e) => e.key === "collected");
        if (tmpi < 0) {
          this.rows.push({
            name: "Collected",
            key: "collected",
            type: "boolean",
            show: true,
            editable: false,
            center: true,
          });
        }
        tmpi = this.rows.findIndex((e) => e.key === "in_package");
        if (tmpi < 0) {
          this.rows.push({
            name: "In package",
            key: "in_package",
            type: "boolean",
            show: true,
            editable: false,
            center: true,
          });
        }
        tmpi = this.rows.findIndex((e) => e.key === "returned");
        if (tmpi > -1) {
          this.rows.splice(tmpi, 1);
        }
      }

      this.orders = undefined;
      if (this.warehouse === undefined || this.warehouse === null) {
        return;
      }
      http
        .fetch(
          `/orders/${
            this.type === "return" ? "returns" : "products"
          }?warehouse=${this.warehouse}&has_problem=${
            this.type === "problems" ? "1" : "0"
          }`
        )
        .then((data) => {
          if (this.firstLoad) {
            this.firstLoad = false;
            for (const cs of data.characteristics) {
              this.rows.splice(3, 0, {
                name: cs.name,
                key: "caracteristics_" + cs.id,
                type: "string",
                show: true,
                editable: false,
              });
            }
          }
          this.orders = Object.values(data.data);
          this.ordersById = {};
          for (const key in this.orders) {
            this.orders[key].packages =
              this.selectedWarehouse.packing_start_boxes;
            this.ordersById[
              this.orders[key].order_package_id
                ? this.orders[key].id + "_" + this.orders[key].order_package_id
                : this.orders[key].id
            ] = this.orders[key];
            for (const itemKey in this.ordersById[
              this.orders[key].order_package_id
                ? this.orders[key].id + "_" + this.orders[key].order_package_id
                : this.orders[key].id
            ].orderItems) {
              let item = this.orders[key].orderItems[itemKey];
              this.itemsById[this.orders[key].orderItems[itemKey].id] = item;

              if (item.image !== null && item.image !== undefined) {
                item.image =
                  item.image.indexOf("http") == 0
                    ? item.image
                    : this.mediaServer + "/" + item.image;
              }
            }
          }
        });
    },
    formatDate(val) {
      return date.format(val, false, false);
    },
    setCollected(order) {
      order.loadCollectBtn = true;
      let oid = order.order_package_id
        ? order.id + "_" + order.order_package_id
        : order.id;
      let i = 0;
      for (const element of this.ordersById[oid].orderItems) {
        if (!element.in_package) {
          for (let e = 0; e < element.need_to_sent_quantity; e++) {
            setTimeout(
              () =>
                this.packaging(order.id, element.id, oid, element.parts_count),
              i * 300
            );
            i++;
          }
        }
      }
      setTimeout(() => (order.loadCollectBtn = false), i * 300);
    },
    generateShipping(order, force = false) {
      if (
        !force &&
        this.selectedWarehouse.notify_for_no_box === true &&
        (order.extraItems === null ||
          order.extraItems === undefined ||
          order.extraItems.length < 1)
      ) {
        let hasMissingItem = false;
        for (const element of order.orderItems) {
          if (!element.in_package) {
            hasMissingItem = true;
          }
        }
        if (!hasMissingItem) {
          this.packingOrder = order;
          this.$refs.confirmPackingModal.showModal();
          return;
        }
      }

      order.loadShipBtn = true;
      http
        .fetch(
          "/orders/delivery",
          {
            order_package_id: order.order_package_id,
            packages: order.packages,
          },
          true
        )
        .then((data) => {
          order.tracking_code = data.tracking_code;
          order.delivery_method_id = data.delivery_method_id;
          order.app_id = data.app_id;
          order.loadShipBtn = false;
          this.printLabel(order.tracking_code, order.app_id);
        })
        .catch(() => {
          order.loadShipBtn = false;
        });
    },
    onPrinterChosen({ printerId, always }) {
      if (always) {
        this.defaultPrinters[this.currentPrintJob.method] = printerId;
      }

      this.showPrinterModal = false;

      this.sendToDesktopPrinter(
        this.currentPrintJob.code,
        this.currentPrintJob.method,
        printerId,
        always
      );
    },
    showMessagesModal(order) {
      this.messages = undefined;
      http.fetch("/orders/" + order.id + "/messages").then((data) => {
        this.messages = data.data;
      });
      this.$refs.messagesModal.showModal();
    },
    showProblemModal(order) {
      if (this.problems.length === 0) {
        http.fetch("/orders/problems/categories").then((data) => {
          this.problems = data;
        });
      }
      this.packingOrder = order;
      this.$refs.selectProblemModal.showModal();
    },
    showSelectShipping(order) {
      if (this.webshops.length === 0) {
        http.fetch("/webshops").then((data) => {
          this.webshops = data;
        });
      }
      this.packingOrder = order;
      this.$refs.selectDeliveryModal.showModal();
    },
    addProblem(packingOrder, problem) {
      this.$refs.selectProblemModal.hideModal();
      const i = this.orders.findIndex((e) => e.id == packingOrder.id);
      if (i > -1) {
        this.orders.splice(i, 1);
      }
      http
        .fetch(
          "/orders/problems",
          {
            order_id: packingOrder.id,
            order_problem_category_id: problem.id,
          },
          false
        )
        .then((data) => {
          console.log(data);
        });
    },
    addDeliveryMethodAndPrint(packingOrder, deliveryMethod) {
      this.$refs.selectDeliveryModal.hideModal();
      http
        .fetch(
          "/orders/" + packingOrder.id,
          {
            delivery: {
              method: deliveryMethod.id,
            },
          },
          false,
          "PUT"
        )
        .then((data) => {
          console.log(data);
          this.generateShipping(packingOrder);
        });
    },
    async sendToDesktopPrinter(code, method, printerId, alwaysUse = false) {
      const fileUrl = `${tenant.getApiBaseUrl()}/deliveries/label/${method}?code=${code}&_token=${
        store.state.token
      }`;

      // FormData
      const fd = new FormData();
      fd.append(
        "printRequest",
        JSON.stringify({
          printerId,
          quantity: 1,
          printRequestType: "" + method,
          alwaysUse,
          fileUrl: fileUrl,
        })
      );

      // Send
      await fetch("http://0.0.0.0:54123/print", {
        method: "POST",
        body: fd,
      });
      const input = document.getElementById("search-bar");
      if (input) {
        input.focus();
        input.select();
      }
    },
    printLabel(code, method) {
      if (this.localPrinters?.length > 0) {
        const defaultPrinter = this.defaultPrinters[method];

        if (defaultPrinter) {
          return this.sendToDesktopPrinter(code, method, defaultPrinter);
        }

        // Show modal to choose printer
        this.showPrinterModal = true;
        this.currentPrintJob = { code, method };
        return;
      }

      const url = `${tenant.getApiBaseUrl()}/deliveries/label/${method}?code=${code}&_token=${
        store.state.token
      }`;

      const _this = this;
      printJS({
        printable: url,
        type: "pdf",
        onLoadingStart: () => {
          console.log("printer loading..");
        },
        onLoadingEnd: () => {
          console.log("start printing");
          document.getElementById("search-bar").focus();
          document.getElementById("search-bar").select();
        },
        onPrintDialogClose: () => {
          TimeTracking.start({
            event: _this.type === "return" ? "returning" : "packing",
          });
        },
        onError: (err) => {
          window.open(url, "_blank");
          console.log("printer error:");
          console.log(err);
        },
      });
    },
    cancelReturnModal(order, item) {
      if (this.type !== "return") {
        return;
      }
      this.cancelItem = {
        order: order,
        item: item,
      };
      this.$refs.confirmModal.showModal();
    },
    cancelReturn() {
      if (this.type !== "return") {
        return;
      }
      http
        .fetch(`/orders/${this.cancelItem.order.id}/cancel-return`, {
          item: this.cancelItem.item.id,
        })
        .then(() => {
          let i = this.ordersById[
            this.cancelItem.order.order_package_id
              ? this.cancelItem.order.id +
                "_" +
                this.cancelItem.order.order_package_id
              : this.cancelItem.order.id
          ].orderItems.indexOf(this.cancelItem.item);
          if (i > -1) {
            this.ordersById[
              this.cancelItem.order.order_package_id
                ? this.cancelItem.order.id +
                  "_" +
                  this.cancelItem.order.order_package_id
                : this.cancelItem.order.id
            ].orderItems.splice(i, 1);
          }
        });
    },
    addToQueue(order, barcode, package_id = null) {
      let oid = package_id ? order + "_" + package_id : order;
      if (barcode === null || barcode.length < 3) {
        return;
      }
      this.ordersById[oid].barcode = "";

      if (!this.barcodeQueues[oid]) {
        this.barcodeQueues[oid] = [];
      }
      this.barcodeQueues[oid].push(barcode);
      this.processQueue(oid, order, package_id);
    },
    async processQueue(oid, orderId, package_id) {
      if (
        this.isProcessingQueue[oid] ||
        !this.barcodeQueues[oid] ||
        this.barcodeQueues[oid].length === 0
      ) {
        return;
      }

      this.isProcessingQueue[oid] = true;

      while (this.barcodeQueues[oid]?.length > 0) {
        const barcode = this.barcodeQueues[oid][0];
        try {
          const result = await this.addToPackageAsync(
            orderId,
            barcode,
            package_id,
            oid
          );
          if (result === "paused") {
            // Processing is paused because a modal is shown (multiple items or error)
            this.isProcessingQueue[oid] = false;
            return;
          }
          // Success, remove from queue and continue
          this.barcodeQueues[oid].shift();
        } catch (err) {
          // Error already handled in addToPackageAsync by showing modal
          this.isProcessingQueue[oid] = false;
          return;
        }
      }

      this.isProcessingQueue[oid] = false;
    },
    addToPackageAsync(order, barcode, package_id = null, oid) {
      return new Promise((resolve, reject) => {
        barcode = barcodeFormat.normalizeInput(barcode);

        const searchVariants = /^\d+$/.test(barcode)
          ? barcodeFormat.normalize(barcode)
          : [barcode];

        this.packagingInfo.icon = 3;
        this.packagingInfo.status = "Searching";
        this.packagingInfo.text = "just a few moments..";

        let elements = this.ordersById[oid].orderItems.filter((e) => {
          const fields = [e.sku, e.ean, e.upc];

          return fields.some(
            (field) =>
              field &&
              barcodeFormat
                .normalize(field)
                .some((variant) =>
                  searchVariants.includes(variant.toLowerCase())
                )
          );
        });

        if (elements.length === 1) {
          this.packaging(order, elements[0].id, oid, elements[0].parts_count)
            .then(() => resolve("success"))
            .catch((err) => reject(err));
        } else if (elements.length > 1) {
          this.packagingInfo.status = "Multiple Barcode found";
          this.packagingInfo.text = "Select the correct product";
          this.packagingInfo.selectedItems = elements;
          this.packagingInfo.selectItemMethod = (p) => {
            this.packaging(order, p.id, oid, p.parts_count).then(() => {
              if (this.barcodeQueues[oid]) {
                this.barcodeQueues[oid].shift();
              }
              this.processQueue(oid, order, package_id);
            });
          };
          this.$refs.packagingModal.showModal();
          resolve("paused");
        } else {
          http
            .fetch("/products/materials/search", { q: barcode })
            .then((data) => {
              if (data.length > 1) {
                this.packagingInfo.status = "Multiple Barcode found";
                this.packagingInfo.text = "Select the correct product";
                this.packagingInfo.selectedItems = data;
                this.packagingInfo.selectItemMethod = (p) => {
                  this.packaging(
                    package_id,
                    p.variant_id,
                    oid,
                    1,
                    true,
                    p
                  ).then(() => {
                    if (this.barcodeQueues[oid]) {
                      this.barcodeQueues[oid].shift();
                    }
                    this.processQueue(oid, order, package_id);
                  });
                };
                this.$refs.packagingModal.showModal();
                resolve("paused");
              } else if (data.length === 1) {
                this.packaging(
                  package_id,
                  data[0].variant_id,
                  oid,
                  1,
                  true,
                  data[0]
                )
                  .then(() => resolve("success"))
                  .catch((err) => reject(err));
              } else {
                this.packagingInfo.icon = 2;
                this.packagingInfo.status = "Barcode not found";
                this.packagingInfo.text =
                  "We cannot find any item with this barcode in this transfer.";
                this.$refs.packagingModal.showModal();
                // We don't want to lose the barcode if it's an error?
                // Actually if it's not found, user needs to fix it.
                // Stopping the queue is safer.
                resolve("paused");
              }
            })
            .catch((err) => reject(err));
        }
      });
    },
    addToPackage(order, barcode, package_id = null) {
      this.addToQueue(order, barcode, package_id);
    },
    packaging(
      order,
      item,
      oid,
      partsCount = 1,
      extra = false,
      itemData = null
    ) {
      return new Promise((resolve, reject) => {
        if (partsCount > 1) {
          if (this.currentPartCount[order] === undefined) {
            this.currentPartCount[order] = {};
          }
          if (this.currentPartCount[order][item] === undefined) {
            this.currentPartCount[order][item] = 0;
          }
          this.currentPartCount[order][item]++;

          if (this.currentPartCount[order][item] !== partsCount) {
            this.packagingInfo.icon = 1;
            this.packagingInfo.status = "Product consists of multiple parts";
            this.packagingInfo.text =
              this.currentPartCount[order][item] + "/" + partsCount;
            this.$refs.packagingModal.showModal();
            // Pause queue for multi-part products to show progress
            // User needs to scan the next part.
            // If we don't resolve here, the queue will stay paused.
            // When user scans next part, it goes to queue and calls processQueue.
            // But processQueue is already "running" (if we don't resolve).
            // Actually multi-part expects user to scan same/another barcode.
            resolve("paused");
            return;
          }
        }
        http
          .fetch(
            `/orders/${order}/${
              extra
                ? "packaging-extra"
                : this.type === "return"
                ? "returned"
                : "packaging"
            }`,
            { item: item }
          )
          .then((data) => {
            if (extra) {
              if (this.ordersById[oid].extraItems === undefined) {
                this.ordersById[oid].extraItems = [];
              }
              this.ordersById[oid].extraItems.push(itemData);
              //this.ordersById[oid].packages += 1;
            } else {
              let e = this.itemsById[item];
              if (e === undefined) {
                resolve();
                return;
              }
              e.need_to_sent_quantity = data.statuses?.need_to_sent_quantity;

              if (data.statuses?.need_to_sent_quantity === 0) {
                e.order_package_id = true;
                e.in_package = true;
              }

              if (data.statuses?.need_to_sent_quantity === null) {
                e.returned = true;
              }
            }

            this.packagingInfo.status =
              this.type === "return"
                ? "The item received in the warehouse"
                : "Item added to the package";
            this.packagingInfo.text =
              this.type === "return"
                ? "The item received in the warehouse"
                : "Item added to the package";
            this.packagingInfo.icon = 1;
            this.ordersById[oid].show_success = true;
            this.ordersById[oid].disable = false;
            setTimeout(() => {
              if (
                this.$refs["serach_box_" + oid] &&
                this.$refs["serach_box_" + oid][0]
              ) {
                this.$refs["serach_box_" + oid][0].focus();
              }
            }, 40);
            setTimeout(() => {
              this.ordersById[oid].show_success = false;
            }, 600);
            resolve();
          })
          .catch((data) => {
            if (this.ordersById[oid]) {
              this.ordersById[oid].disable = false;
            }
            this.packagingInfo.icon = 2;
            this.packagingInfo.status = "Error";
            this.packagingInfo.text = data.message;
            this.$refs.packagingModal.showModal();
            reject(data);
          });
      });
    },
    onScanModalHidden() {
      // Clear all queues if a modal is closed.
      // This ensures the spinner disappears and the state is clean.
      // The user might have closed it because they want to stop or fix something.
      this.barcodeQueues = {};
      this.isProcessingQueue = {};
    },
    // time tracking methods
    startOrderTracking(order) {
      TimeTracking.start({
        event: this.type === "return" ? "returning" : "packing",
        orderId: order.id,
      });
    },
  },
};
</script>
<style scoped>
.contact-message {
  position: relative;
  margin-bottom: 2rem;
}
.contact-message::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  width: 16px;
  height: 16px;
  background: #0d6efd;
  border-radius: 50%;
  border: 2px solid #fff;
}
.contact-message-meta {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
  margin-left: 3em;
}
.contact-message-content {
  white-space: pre-wrap;
  background: #f8f9fa;
  padding: 0.75rem;
  border-radius: 0.375rem;
}
</style>
